import { Button } from "@/components/ui/button"
import { Menu, X } from "lucide-react"
import { useState } from "react"
import { DemoBookingModal } from "./demo-booking-modal"
import { ResourceGateModal, checkResourceAccess } from "./resource-gate-modal"

const RESOURCE_URL = "https://www.npmjs.com/package/n8n-nodes-bridgegate"

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [demoModalOpen, setDemoModalOpen] = useState(false)
  const [resourceModalOpen, setResourceModalOpen] = useState(false)

  // Check if user already has access before opening modal
  const handleResourceAccess = () => {
    if (checkResourceAccess()) {
      // User already has access, open resource directly
      window.open(RESOURCE_URL, '_blank')
    } else {
      // Show the gate modal
      setResourceModalOpen(true)
    }
  }

  return (
    <>
      <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center gap-8">
              <a href="https://vorro.net" className="flex items-center">
                <img
                  src="https://vorro.net/logo/logo.webp"
                  alt="Vorro"
                  style={{ height: '28px', width: 'auto' }}
                  loading="eager"
                />
              </a>

              <nav className="hidden md:flex items-center gap-6">
                <a href="#bridgegate-n8n" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors">
                  BridgeGate N8N node
                </a>
                <a href="#solutions" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors">
                  Solutions
                </a>
                <a href="#case-studies" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors">
                  Case Studies
                </a>
                <a href="#why-vorro" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors">
                  Why Vorro
                </a>
              </nav>
            </div>

            <div className="hidden md:flex items-center gap-4">
              <button 
                onClick={handleResourceAccess}
                className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
              >
                Docs
              </button>
              <Button 
                onClick={() => setDemoModalOpen(true)}
                className="bg-[linear-gradient(135deg,#a63083,#bf406a)] hover:opacity-90 text-white font-medium px-5 h-9 rounded-md"
              >
                Talk to an Expert
              </Button>
            </div>

            <button
              className="md:hidden p-2 text-gray-600"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-100">
              <nav className="flex flex-col gap-3">
                <a href="#bridgegate-n8n" className="text-sm font-medium text-gray-600 hover:text-gray-900 py-2">
                  BridgeGate N8N node
                </a>
                <a href="#solutions" className="text-sm font-medium text-gray-600 hover:text-gray-900 py-2">
                  Solutions
                </a>
                <a href="#case-studies" className="text-sm font-medium text-gray-600 hover:text-gray-900 py-2">
                  Case Studies
                </a>
                <a href="#why-vorro" className="text-sm font-medium text-gray-600 hover:text-gray-900 py-2">
                  Why Vorro
                </a>
                <button 
                  onClick={handleResourceAccess}
                  className="text-sm font-medium text-gray-600 hover:text-gray-900 py-2 text-left"
                >
                  Docs
                </button>
                <Button 
                  onClick={() => setDemoModalOpen(true)}
                  className="bg-[linear-gradient(135deg,#a63083,#bf406a)] hover:opacity-90 text-white font-medium mt-2 w-full"
                >
                  Talk to an Expert
                </Button>
              </nav>
            </div>
          )}
        </div>
      </header>

      <DemoBookingModal open={demoModalOpen} onOpenChange={setDemoModalOpen} />
      <ResourceGateModal 
        open={resourceModalOpen} 
        onOpenChange={setResourceModalOpen}
        resourceUrl={RESOURCE_URL}
        resourceName="n8n Node Documentation"
      />
    </>
  )
}
